import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getManualDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  manualWelcomePage: [
    {
      fieldName: "Introduction (EN)",
      fieldValue: "field_introduction_manual_header",
      className: "col-span-6",
      type: "text",
      name: "field_introduction_manual_header",
      formType: "input",
      label: "Introduction (EN)",
      placeholder: "Enter Introduction",
      validation: { required: "Introduction is required" },
    },
    {
      fieldName: "Introduction (MS)",
      fieldValue: "field_malay_introduction_manual",
      className: "col-span-6",
      type: "text",
      name: "field_malay_introduction_manual",
      formType: "input",
      label: "Introduction (MS)",
      placeholder: "Enter Malay Introduction",
      // validation: { required: "Malay Introduction is required" },
    },
    {
      fieldName: "Introduction (ZH)",
      fieldValue: "field_mandarin_introduction_manu",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_introduction_manu",
      formType: "input",
      label: "Introduction (ZH)",
      placeholder: "Enter Mandarin Introduction",
      // validation: { required: "Mandarin Introduction is required" },
    },
    {
      fieldName: "Welcome to Procurement Manual (EN)",
      fieldValue: "field_manual_welcome_sub_text",
      className: "col-span-6",
      type: "text",
      name: "field_manual_welcome_sub_text",
      formType: "input",
      label: "Welcome to Procurement Manual (EN)",
      placeholder: "Enter Welcome to Procurement Manual (EN)",
      validation: { required: "Welcome to Procurement Manual (EN) is required" },
    },
    {
      fieldName: "Welcome to Procurement Manual (MS)",
      fieldValue: "field_malay_manual_welcome_sub_t",
      className: "col-span-6",
      type: "text",
      name: "field_malay_manual_welcome_sub_t",
      formType: "input",
      label: "Welcome to Procurement Manual (MS)",
      placeholder: "Enter Welcome to Procurement Manual (MS)",
      // validation: { required: "Malay Welcome Sub Text is required" },
    },
    {
      fieldName: "Welcome to Procurement Manual (ZH)",
      fieldValue: "field_mandarin_manu_welc_sub_tex",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_manu_welc_sub_tex",
      formType: "input",
      label: "Welcome to Procurement Manual (ZH)",
      placeholder: "Enter Welcome to Procurement Manual (ZH)",
      // validation: { required: "Mandarin Welcome Sub Text is required" },
    },
    {
      fieldName: "Welcome Description (EN)",
      fieldValue: "field_manual_welcome_description",
      className: "col-span-6",
      type: "text",
      name: "field_manual_welcome_description",
      formType: "richText",
      label: "Welcome Description (EN)",
      placeholder: "Enter Welcome Description (EN)",
      validation: { required: "Welcome Description (EN) is required" },
    },
    {
      fieldName: "Welcome Description (MS)",
      fieldValue: "field_malay_manual_welcome_descr",
      className: "col-span-6",
      type: "text",
      name: "field_malay_manual_welcome_descr",
      formType: "richText",
      label: "Welcome Description (MS)",
      placeholder: "Enter Welcome Description (MS)",
      // validation: { required: "Malay Welcome Description is required" },
    },
    {
      fieldName: "Welcome Description (ZH)",
      fieldValue: "field_mandarin_manual_welcom_des",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_manual_welcom_des",
      formType: "richText",
      label: "Welcome Description (ZH)",
      placeholder: "Enter Welcome Description (ZH)",
      // validation: { required: "Mandarin Welcome Description is required" },
    },
    {
      fieldName: "Continue Text (EN)",
      fieldValue: "field_manual_welcom_continue",
      className: "col-span-6",
      type: "text",
      name: "field_manual_welcom_continue",
      formType: "input",
      label: "Continue Text (EN)",
      placeholder: "Enter Continue Text (EN)",
      validation: { required: "Continue Text (EN) is required" },
    },
    {
      fieldName: "Continue Text (MS)",
      fieldValue: "field_malay_manual_continue_text",
      className: "col-span-6",
      type: "text",
      name: "field_malay_manual_continue_text",
      formType: "input",
      label: "Continue Text (MS)",
      placeholder: "Enter Malay Continue Text (MS)",
      // validation: { required: "Malay Continue Text is required" },
    },
    {
      fieldName: "Continue Text (ZH)",
      fieldValue: "field_mandarin_manual_continue",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_manual_continue",
      formType: "input",
      label: "Continue Text (ZH)",
      placeholder: "Enter Mandarin Continue Text (ZH)",
      // validation: { required: "Mandarin Continue Text is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_magp_image",
      className: "col-span-6",
      type: "image",
      name: "field_magp_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Enter Image URL",
      validation: { required: "Image URL is required" },
    },
  ],
  procurementPlanning: [
    // {
    //   fieldName: "Title",
    //   fieldValue: "title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "title",
    //   formType: "input",
    //   label: "Business Case Title",
    //   placeholder: "Enter Business Case Title",
    //   validation: { required: "Business Case Title is required" },
    // },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_procurement_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_procurement_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_procurement_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_procurement_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_procurement_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_procurement_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Video URL",
      fieldValue: "field_procurement_video_url",
      className: "col-span-6",
      type: "video",
      name: "field_procurement_video_url",
      formType: "file",
      usedFileType: 'video/*',
      label: "Video URL",
      placeholder: "Enter Video URL",
      // validation: { required: "Video URL is required" },
    },
    {
      fieldName: "Web Image",
      fieldValue: "field_procure_details_web_image",
      className: "col-span-6",
      type: "image",
      name: "field_procure_details_web_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Web Image",
      placeholder: "Enter Web Image URL",
      validation: { required: "Web Image URL is required" },
    },
    // {
    //   fieldName: "Web Flowchart Image",
    //   fieldValue: "field_procurement_web_flowchart",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_procurement_web_flowchart",
    //   formType: "file",
    //   label: "Web Image",
    //   placeholder: "Enter Web Flowchart Image URL",
    //   validation: { required: "Web Flowchart Image URL is required" },
    // },
  ],

  procurementPlanningProcessFlowChart: [
    {
      fieldName: "Project Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Project Title (EN)",
      placeholder: "Enter project title (EN)",
      validation: { required: "Project Title (EN) is required" },
    },
    {
      fieldName: "Project Title (MS)",
      fieldValue: "field_procure_process_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_procure_process_title_ms",
      formType: "input",
      label: "Project Title (MS)",
      placeholder: "Enter project title (MS)",
      // validation: { required: "Project Title (MS) is required" },
    },
    {
      fieldName: "Project Title (ZH)",
      fieldValue: "field_procure_process_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_procure_process_title_zh",
      formType: "input",
      label: "Project Title (ZH)",
      placeholder: "Enter project title (ZH)",
      // validation: { required: "Project Title (ZH) is required" },
    },
    {
      fieldName: "Project Description (EN)",
      fieldValue: "field_procure_flow_chart_des_en",
      className: "col-span-6",
      type: "text",
      name: "field_procure_flow_chart_des_en",
      formType: "richText",
      label: "Project Description (EN)",
      placeholder: "Enter project description (EN)",
      validation: { required: "Project Description (EN) is required" },
    },
    {
      fieldName: "Project Description (MS)",
      fieldValue: "field_procure_flow_chart_des_ms",
      className: "col-span-6",
      type: "text",
      name: "field_procure_flow_chart_des_ms",
      formType: "richText",
      label: "Project Description (MS)",
      placeholder: "Enter project description (MS)",
      // validation: { required: "Project Description (MS) is required" },
    },
    {
      fieldName: "Project Description (ZH)",
      fieldValue: "field_procure_flow_chart_des_zh",
      className: "col-span-6",
      type: "text",
      name: "field_procure_flow_chart_des_zh",
      formType: "richText",
      label: "Project Description (ZH)",
      placeholder: "Enter project description (ZH)",
      // validation: { required: "Project Description (ZH) is required" },
    },
  ],
  requisition: [
    {
      fieldName: "Description (EN)",
      fieldValue: "field_requisition_desc_en",
      className: "col-span-6",
      type: "text",
      name: "field_requisition_desc_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_requisition_desc_ms",
      className: "col-span-6",
      type: "text",
      name: "field_requisition_desc_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_requisition_desc_zh",
      className: "col-span-6",
      type: "text",
      name: "field_requisition_desc_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Video URL",
      fieldValue: "field_requisition_video_url",
      className: "col-span-6",
      type: "video",
      name: "field_requisition_video_url",
      formType: "file",
      usedFileType: 'video/*',
      label: "Video URL",
      placeholder: "Enter Video URL",
      // validation: { required: "Video URL is required" },
    },
    {
      fieldName: "Web Image",
      fieldValue: "field_requisit_details_web_image",
      className: "col-span-6",
      type: "image",
      name: "field_requisit_details_web_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Web Image",
      placeholder: "Enter Web Image URL",
      validation: { required: "Web Image URL is required" },
    },
    // {
    //   fieldName: "Web Flowchart",
    //   fieldValue: "field_requisition_web_flowchart",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_requisition_web_flowchart",
    //   formType: "file",
    //   label: "Web Flowchart",
    //   placeholder: "Enter Web Flowchart URL",
    // },
  ],
  requisitionProcessFlowChart: [
    {
      fieldName: "Project Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Project Title (EN)",
      placeholder: "Enter project title (EN)",
      validation: { required: "Project Title (EN) is required" },
    },
    {
      fieldName: "Project Title (MS)",
      fieldValue: "field_req_process_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_req_process_title_ms",
      formType: "input",
      label: "Project Title (MS)",
      placeholder: "Enter project title (MS)",
      // validation: { required: "Project Title (MS) is required" },
    },
    {
      fieldName: "Project Title (ZH)",
      fieldValue: "field_req_process_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_req_process_title_zh",
      formType: "input",
      label: "Project Title (ZH)",
      placeholder: "Enter project title (ZH)",
      // validation: { required: "Project Title (ZH) is required" },
    },
    {
      fieldName: "Project Description (EN)",
      fieldValue: "field_requi_flow_chart_desc_en",
      className: "col-span-6",
      type: "text",
      name: "field_requi_flow_chart_desc_en",
      formType: "richText",
      label: "Project Description (EN)",
      placeholder: "Enter project description (EN)",
      validation: { required: "Project Description (EN) is required" },
    },
    {
      fieldName: "Project Description (MS)",
      fieldValue: "field_requi_flow_chart_desc_ms",
      className: "col-span-6",
      type: "text",
      name: "field_requi_flow_chart_desc_ms",
      formType: "richText",
      label: "Project Description (MS)",
      placeholder: "Enter project description (MS)",
      // validation: { required: "Project Description (MS) is required" },
    },
    {
      fieldName: "Project Description (ZH)",
      fieldValue: "field_requi_flow_chart_desc_zh",
      className: "col-span-6",
      type: "text",
      name: "field_requi_flow_chart_desc_zh",
      formType: "richText",
      label: "Project Description (ZH)",
      placeholder: "Enter project description (ZH)",
      // validation: { required: "Project Description (ZH) is required" },
    },
  ],

  contractAdministration: [
    // {
    //   fieldName: "Title",
    //   fieldValue: "title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "title",
    //   formType: "input",
    //   label: "Title",
    //   placeholder: "Enter Title",
    //   validation: { required: "Title is required" },
    // },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_contract_admin_desc_en",
      className: "col-span-6",
      type: "text",
      name: "field_contract_admin_desc_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_contract_admin_desc_ms",
      className: "col-span-6",
      type: "text",
      name: "field_contract_admin_desc_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_contract_admin_desc_zh",
      className: "col-span-6",
      type: "text",
      name: "field_contract_admin_desc_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Video URL",
      fieldValue: "field_contract_video_url",
      className: "col-span-6",
      type: "video",
      name: "field_contract_video_url",
      formType: "file",
      usedFileType: 'video/*',
      label: "Video URL",
      placeholder: "Enter Video URL",
      // validation: { required: "Video URL is required" },
    },
    {
      fieldName: "Web Image",
      fieldValue: "field_contract_details_web_image",
      className: "col-span-6",
      type: "image",
      name: "field_contract_details_web_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Web Image",
      placeholder: "Enter Web Image URL",
      validation: { required: "Web Image URL is required" },
    },
    // {
    //   fieldName: "Web Flowchart",
    //   fieldValue: "field_contract_web_flowchart_img",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_contract_web_flowchart_img",
    //   formType: "file",
    //   label: "Web Flowchart",
    //   placeholder: "Enter Web Flowchart URL",
    // },
  ],
  contractAdministrationProcessFlowChart: [
    {
      fieldName: "Project Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Project Title (EN)",
      placeholder: "Enter project title (EN)",
      validation: { required: "Project Title (EN) is required" },
    },
    {
      fieldName: "Project Title (MS)",
      fieldValue: "field_contract_process_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_contract_process_title_ms",
      formType: "input",
      label: "Project Title (MS)",
      placeholder: "Enter project title (MS)",
      // validation: { required: "Project Title (MS) is required" },
    },
    {
      fieldName: "Project Title (ZH)",
      fieldValue: "field_contract_process_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_contract_process_title_zh",
      formType: "input",
      label: "Project Title (ZH)",
      placeholder: "Enter project title (ZH)",
      // validation: { required: "Project Title (ZH) is required" },
    },
    {
      fieldName: "Project Description (EN)",
      fieldValue: "field_contract_flow_chart_des_en",
      className: "col-span-6",
      type: "text",
      name: "field_contract_flow_chart_des_en",
      formType: "richText",
      label: "Project Description (EN)",
      placeholder: "Enter project description (EN)",
      validation: { required: "Project Description (EN) is required" },
    },
    {
      fieldName: "Project Description (MS)",
      fieldValue: "field_contract_flow_chart_des_ms",
      className: "col-span-6",
      type: "text",
      name: "field_contract_flow_chart_des_ms",
      formType: "richText",
      label: "Project Description (MS)",
      placeholder: "Enter project description (MS)",
      // validation: { required: "Project Description (MS) is required" },
    },
    {
      fieldName: "Project Description (ZH)",
      fieldValue: "field_contract_flow_chart_des_zh",
      className: "col-span-6",
      type: "text",
      name: "field_contract_flow_chart_des_zh",
      formType: "richText",
      label: "Project Description (ZH)",
      placeholder: "Enter project description (ZH)",
      // validation: { required: "Project Description (ZH) is required" },
    },
  ],

  vendorManagement: [
    // {
    //   fieldName: "Title",
    //   fieldValue: "title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "title",
    //   formType: "input",
    //   label: "Business Case Title",
    //   placeholder: "Enter Business Case Title",
    //   validation: { required: "Business Case Title is required" },
    // },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_vendor_management_desc_en",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_management_desc_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_vendor_management_desc_ms",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_management_desc_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_vendor_management_desc_zh",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_management_desc_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Video URL",
      fieldValue: "field_vendor_video_url",
      className: "col-span-6",
      type: "video",
      name: "field_vendor_video_url",
      formType: "file",
      usedFileType: 'video/*',
      label: "Video URL",
      placeholder: "Enter Video URL",
      // validation: { required: "Video URL is required" },
    },
    {
      fieldName: "Web Image",
      fieldValue: "field_vendor_details_web_image",
      className: "col-span-6",
      type: "image",
      name: "field_vendor_details_web_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Web Image",
      placeholder: "Enter Web Image URL",
      validation: { required: "Web Image URL is required" },
    },
    // {
    //   fieldName: "Web FlowChart Image",
    //   fieldValue: "field_vendor_web_flowchart_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_vendor_web_flowchart_image",
    //   formType: "file",
    //   label: "Web FlowChart Image",
    //   placeholder: "Enter Web FlowChart Image URL",
    //   validation: { required: "Web Flowchart Image URL is required" },
    // },
  ],

  vendorManagementProcessFlowChart: [
    {
      fieldName: "Project Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Project Title",
      placeholder: "Enter project title",
      validation: { required: "Project Title is required" },
    },
    {
      fieldName: "Project Title (MS)",
      fieldValue: "field_vendor_process_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_process_title_ms",
      formType: "input",
      label: "Project Title (MS)",
      placeholder: "Enter Project Title (MS)",
      // validation: { required: "Project Title (MS) is required" },
    },
    {
      fieldName: "Project Title (ZH)",
      fieldValue: "field_vendor_process_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_process_title_zh",
      formType: "input",
      label: "Project Title (ZH)",
      placeholder: "Enter Project Title (ZH)",
      // validation: { required: "Project Title (ZH) is required" },
    },
    {
      fieldName: "Project Description (EN)",
      fieldValue: "field_vendor_flow_chart_desc_en",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_flow_chart_desc_en",
      formType: "richText",
      label: "Project Description (EN)",
      placeholder: "Enter project description",
      validation: { required: "Project Description is required" },
    },
    {
      fieldName: "Project Description (MS)",
      fieldValue: "field_vendor_flow_chart_desc_ms",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_flow_chart_desc_ms",
      formType: "richText",
      label: "Project Description (MS)",
      placeholder: "Enter Project Description (MS)",
      // validation: { required: "Project Description (MS) is required" },
    },
    {
      fieldName: "Project Description (ZH)",
      fieldValue: "field_vendor_flow_chart_desc_zh",
      className: "col-span-6",
      type: "text",
      name: "field_vendor_flow_chart_desc_zh",
      formType: "richText",
      label: "Project Description (ZH)",
      placeholder: "Enter Project Description (ZH)",
      // validation: { required: "Project Description (ZH) is required" },
    },
  ],

  sourcing: [
    // {
    //   fieldName: "Title",
    //   fieldValue: "title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "title",
    //   formType: "input",
    //   label: "Flow Chart Title",
    //   placeholder: "Enter Flow Chart Title",
    //   validation: { required: "Flow Chart Title is required" },
    // },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_sourcing_desc_en",
      className: "col-span-6",
      type: "text",
      name: "field_sourcing_desc_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_sourcing_desc_ms",
      className: "col-span-6",
      type: "text",
      name: "field_sourcing_desc_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_sourcing_desc_zh",
      className: "col-span-6",
      type: "text",
      name: "field_sourcing_desc_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
    },
    {
      fieldName: "Video URL",
      fieldValue: "field_sourcing_video_url",
      className: "col-span-6",
      type: "video",
      name: "field_sourcing_video_url",
      formType: "file",
      usedFileType: 'video/*',
      label: "Video URL",
      placeholder: "Enter Video URL",
    },
    {
      fieldName: "Web Image",
      fieldValue: "field_sourcing_details_web_image",
      className: "col-span-6",
      type: "image",
      name: "field_sourcing_details_web_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Web Image",
      placeholder: "Enter Web Image URL",
      validation: { required: "Web Image URL is required" },
    },
    {
      fieldName: "Flowchart Image",
      fieldValue: "field_sourcing_web_flowchart_img",
      className: "col-span-6",
      type: "image",
      name: "field_sourcing_web_flowchart_img",
      formType: "file",
      usedFileType: 'image/*',
      label: "Flowchart Image",
      placeholder: "Enter Flowchart Image URL",
    },
  ],
  sourcingProcessFlowChart: [
    {
      fieldName: "Project Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Project Title (EN)",
      placeholder: "Enter project title (EN)",
      validation: { required: "Project Title (EN) is required" },
    },
    {
      fieldName: "Project Title (MS)",
      fieldValue: "field_sourcing_process_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_sourcing_process_title_ms",
      formType: "input",
      label: "Project Title (MS)",
      placeholder: "Enter Project Title (MS)",
      // validation: { required: "Project Title (MS) is required" },
    },
    {
      fieldName: "Project Title (ZH)",
      fieldValue: "field_sourcing_process_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_sourcing_process_title_zh",
      formType: "input",
      label: "Project Title (ZH)",
      placeholder: "Enter Project Title (ZH)",
      // validation: { required: "Project Title (ZH) is required" },
    },
    {
      fieldName: "Project Description (EN)",
      fieldValue: "field_sourcing_flow_chart_des_en",
      className: "col-span-6",
      type: "text",
      name: "field_sourcing_flow_chart_des_en",
      formType: "richText",
      label: "Project Description (EN)",
      placeholder: "Enter project description",
      validation: { required: "Project Description is required" },
    },
    {
      fieldName: "Project Description (MS)",
      fieldValue: "field_sourcing_flow_chart_des_ms",
      className: "col-span-6",
      type: "text",
      name: "field_sourcing_flow_chart_des_ms",
      formType: "richText",
      label: "Project Description (MS)",
      placeholder: "Enter Project Description (MS)",
      // validation: { required: "Project Description (MS) is required" },
    },
    {
      fieldName: "Project Description (ZH)",
      fieldValue: "field_sourcing_flow_chart_des_zh",
      className: "col-span-6",
      type: "text",
      name: "field_sourcing_flow_chart_des_zh",
      formType: "richText",
      label: "Project Description (ZH)",
      placeholder: "Enter Project Description (ZH)",
      // validation: { required: "Project Description (ZH) is required" },
    },
  ],

  introduction: [
    // {
    //   fieldName: "Title",
    //   fieldValue: "title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "title",
    //   formType: "input",
    //   label: "Title",
    //   placeholder: "Enter the Title",
    //   validation: { required: "Title is required" },
    // },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_introduction_description",
      className: "col-span-6",
      type: "text",
      name: "field_introduction_description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_intro_description_malay",
      className: "col-span-6",
      type: "text",
      name: "field_intro_description_malay",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_intro_description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "field_intro_description_mandarin",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Video URL",
      fieldValue: "field_video_url",
      className: "col-span-6",
      type: "video",
      name: "field_video_url",
      formType: "file",
      usedFileType: 'video/*',
      label: "Video URL",
      placeholder: "Enter Video URL",
      // validation: { required: "Video URL is required" },
    },
    {
      fieldName: "Web Image",
      fieldValue: "field_intro_details_web_image",
      className: "col-span-6",
      type: "image",
      name: "field_intro_details_web_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Web Image",
      placeholder: "Enter Web Image URL",
      validation: { required: "Web Image URL is required" },
    },
  ],
};
